var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoint2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 125,
    viewBox: "0 0 124 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62.7681,
    r: 62,
    fill: "url(#paint0_linear_224_188)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7124 79.7681V74.4499L62.1385 62.9442C63.1953 61.9215 64.0817 61.001 64.7976 60.1828C65.5249 59.3647 66.076 58.5635 66.451 57.7794C66.826 56.984 67.0135 56.126 67.0135 55.2056C67.0135 54.1828 66.7805 53.3022 66.3146 52.5635C65.8487 51.8135 65.2124 51.2397 64.4055 50.8419C63.5987 50.4328 62.6839 50.2283 61.6612 50.2283C60.593 50.2283 59.6612 50.4442 58.8658 50.876C58.0703 51.3078 57.4567 51.9272 57.0249 52.734C56.593 53.5408 56.3771 54.501 56.3771 55.6147H49.3714C49.3714 53.3306 49.8885 51.3476 50.9226 49.6658C51.9567 47.984 53.4055 46.6828 55.2692 45.7624C57.1328 44.8419 59.2805 44.3817 61.7124 44.3817C64.2124 44.3817 66.3885 44.8249 68.2408 45.7112C70.1044 46.5862 71.5533 47.8022 72.5874 49.359C73.6215 50.9158 74.1385 52.6999 74.1385 54.7112C74.1385 56.0294 73.8771 57.3306 73.3544 58.6147C72.843 59.8987 71.9283 61.3249 70.6101 62.8931C69.2919 64.4499 67.4339 66.3192 65.0362 68.501L59.9396 73.4953V73.734H74.5987V79.7681H49.7124Z",
    fill: "#01033D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_188",
    x1: -15.0453,
    y1: -29.6974,
    x2: 27.7955,
    y2: 109.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0E4FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint2);
export default __webpack_public_path__ + "static/media/point2.f19ead13dbf1e89b83496a32c9ce91f6.svg";
export { ForwardRef as ReactComponent };